module.exports = __webpack_public_path__ + "static/assets/7e90e85b606d861aeb5aecaf539040be.svg";